// The question the recording answers, as the page edits it. Its checks are
// the contract's, so the page refuses exactly what the route would.
import {
  type ItemRef,
  MAX_PROMPT_CHARS,
  MAX_PROMPT_WORDS,
  promptWordCount,
} from "@bindery/speech/contract";

export interface PromptFields {
  readonly promptText: string;
  readonly itemKind: ItemRef["kind"];
  readonly itemId: string;
  readonly language: string;
  // Which try at this item the next submit is; the route caps it.
  readonly attempt: number;
}

export const ITEM_KINDS: readonly ItemRef["kind"][] = [
  "comprehension-question",
  "retelling",
  "free-response",
];

// What the selector says. The wire value stays the contract's; the label
// says what the kind means for a tester choosing one — a free response is
// a question with no right or wrong answer.
export const ITEM_KIND_LABELS: Readonly<Record<ItemRef["kind"], string>> = {
  "comprehension-question": "comprehension question",
  retelling: "retelling",
  "free-response": "open question (no right answer)",
};

export const newItemId = (): string => `lab-${Date.now().toString(36)}`;

export const initialPrompt = (): PromptFields => ({
  promptText: "What did the dog do when it found the ball?",
  itemKind: "comprehension-question",
  itemId: newItemId(),
  language: "en-US",
  attempt: 1,
});

export interface PromptMeasure {
  readonly words: number;
  readonly chars: number;
  readonly withinLimits: boolean;
}

export const measurePrompt = (text: string): PromptMeasure => {
  const words = promptWordCount(text);
  return {
    words,
    chars: text.length,
    withinLimits: words <= MAX_PROMPT_WORDS && text.length <= MAX_PROMPT_CHARS,
  };
};
